import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { NestedProductCategoryDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, NestedProductCategoryDto>({
        query: (payload) => ({
            url: APP_ENDPOINTS.NESTED_PRODUCT_CATEGORIES,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [{ type: 'nested-product-categories', id: 'GET' }],
    });
